import React, { Fragment, useEffect, useRef, useState } from "react";

import axios from "../../helpers/axios";

import { Notification } from "../../webtracking/components";

const BranchEtaTable = () => {
  const viewport = useRef(null);
  const [width, setWidth] = useState(0);

  const sizes = {
    cols: Math.floor(width / 50),
    rows: 12,
    cell: 50,
  };

  const [message, setMessage] = useState({ level: "error", message: "" });

  const [offsetX, setOffsetX] = useState(0);
  const [offsetY, setOffsetY] = useState(0);

  const [hoverX, setHoverX] = useState(-1);
  const [hoverY, setHoverY] = useState(-1);

  const [branches, setBranches] = useState([]);
  const [edges, setEdges] = useState(new Map());

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    const sizes = viewport.current.getBoundingClientRect();
    setWidth(sizes.width);
  }, [viewport]);

  const cols = [];
  for (let i = 0; i < sizes.cols - 1; i += 1) {
    if (i + offsetX < branches.length) {
      cols.push(i + offsetX);
    }
  }

  const rows = [];
  for (let i = 0; i < sizes.rows - 1; i += 1) {
    if (i + offsetY < branches.length) {
      rows.push(i + offsetY);
    }
  }

  const handleWheel = (event) => {
    event.preventDefault();

    if (event.deltaX > 0) {
      if (offsetX + sizes.cols - 1 < branches.length) {
        setOffsetX(offsetX + 1);
      }
    } else if (event.deltaX < 0) {
      if (offsetX > 0) {
        setOffsetX(offsetX - 1);
      }
    }

    if (event.deltaY > 0) {
      if (offsetY + sizes.rows - 1 < branches.length) {
        setOffsetY(offsetY + 1);
      }
    } else if (event.deltaY < 0) {
      if (offsetY > 0) {
        setOffsetY(offsetY - 1);
      }
    }
  };

  const updateDeliveryTime = (col, row) => {
    const source = branches[row];
    const destination = branches[col];

    const deliveryTime = prompt(
      `Tiempo desde ${source.id} - ${source.name} hasta ${destination.id} - ${destination.name}`
    );

    if (!deliveryTime) {
      return;
    }

    axios
      .post("/api/branch_route/", {
        source: source.id,
        destination: destination.id,
        delivery_time: deliveryTime,
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          edges.set(`${source.id}-${destination.id}`, deliveryTime);
          setEdges(new Map(edges));
        }

        setMessage({
          level: "success",
          message: "Se guardó la información",
        });
      })
      .catch(() => {
        setMessage({
          level: "error",
          message: "No se pudo guardar la información",
        });
      });
  };

  const loadData = async () => {
    let response = await axios.get("/api/branch/");
    const branches = response.data.results;

    const edges = new Map();
    response = await axios.get("/api/branch_route/");
    const routes = response.data.results;
    for (let i = 0; i < routes.length; i += 1) {
      const edge = routes[i];
      edges.set(`${edge.source}-${edge.destination}`, edge.delivery_time);
    }

    setBranches(branches);
    setEdges(edges);
  };

  return (
    <Fragment>
      <Notification {...message} />

      <div ref={viewport}>
        {branches.length ? (
          <div
            className="dynamic-table card has-text-grey"
            style={{
              width: sizes.cell * sizes.cols,
              height: sizes.cell * sizes.rows,
            }}
            onWheel={handleWheel}
            onMouseLeave={() => {
              setHoverX(-1);
              setHoverY(-1);
            }}
          >
            <div className="row">
              <div className="cell">\</div>
              {cols.map((col, jx) => (
                <div
                  key={col}
                  className={"cell" + (hoverX === jx ? " is-active" : "")}
                  title={branches[col].name}
                  onMouseEnter={() => {
                    setHoverX(-1);
                    setHoverY(-1);
                  }}
                >
                  {branches[col].id}
                </div>
              ))}
            </div>
            {rows.map((row, ix) => (
              <div
                key={row}
                className={"row" + (hoverY === ix ? " is-active" : "")}
              >
                <div
                  className="cell"
                  title={branches[row].name}
                  onMouseEnter={() => {
                    setHoverX(-1);
                    setHoverY(-1);
                  }}
                >
                  {branches[row].id}
                </div>
                {cols.map((col, jx) => (
                  <div
                    key={col}
                    className={"cell" + (hoverX === jx ? " is-active" : "")}
                    onClick={updateDeliveryTime.bind(this, col, row)}
                    onMouseEnter={() => {
                      setHoverY(ix);
                      setHoverX(jx);
                    }}
                  >
                    {edges.get(`${branches[row].id}-${branches[col].id}`) ||
                      (branches[row].id === branches[col].id ? "0" : "-")}
                  </div>
                ))}
              </div>
            ))}
            <div>
              <div
                className="scrollbar"
                style={{
                  top: sizes.cell * sizes.rows + 4,
                  marginLeft:
                    (sizes.cell * sizes.cols * offsetX) / (branches.length + 1),
                  width:
                    (sizes.cell * sizes.cols * sizes.cols) /
                    (branches.length + 1),
                }}
              ></div>

              <div
                className="scrollbar"
                style={{
                  left: sizes.cell * sizes.cols + 4,
                  top:
                    (sizes.cell * sizes.rows * offsetY) / (branches.length + 1),
                  height:
                    (sizes.cell * sizes.rows * sizes.rows) /
                    (branches.length + 1),
                }}
              ></div>
            </div>
          </div>
        ) : null}
      </div>
    </Fragment>
  );
};

export default BranchEtaTable;
